// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aI0de","delete":"styles_delete__3mMHu","update":"styles_update__wCmIO","add":"styles_add__eu4ey"};